export default __webpack_public_path__ + "static/media/Estimation_tool.8c658f8f.svg";